/**
 * @Author: 左建
 * @Date: 2022/8/2 9:35
 * @LastEditTime: 2022/8/2 9:35
 * @Description: element ui form-item组件的一些配置
 */

export default {
  props: {
    prop: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: String
    },
    rules: {
      type: Array
    },
    showMessage: {
      type: Boolean
    },
    // 以行内形式展示检验信息
    inlineMessage: {
      type: Boolean
    },
    toolTip: {
      type: String,
      default: ''
    },
    isShowFormItem: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getFormItemProps () {
      const {
        prop,
        labelWidth,
        rules,
        showMessage,
        inlineMessage
      } = this
      return {
        prop,
        labelWidth,
        rules,
        showMessage,
        inlineMessage
      }
    }
  },
  methods: {
    /**
     * @description 获取formItem实例对象
     */
    getFormItemInstance () {
      return this.$refs.formItem
    }
  }
}
